<template>
  <common-confirm v-model="value"
                  is-custom-title
                  width="70%"
                  :z-index="999999"
                  cancelButtonText="退出"
                  confirmButtonText="同意并继续"
                  @confirm="submitAgree"
                  @cancel="submitAgree">
    <template slot="title">
      <div class="privacy-modal-title">《皇家游享荟项目细则》<br/>更新提醒</div>
    </template>
    <template slot="content">
      <div class="privacy-modal-content">
        为持续完善会员服务机制，我们更新了《皇家游享荟项目细则》，明确了符合条件的预订以及积分规则等内容。请您点击<a :href="rewardPrivacyLink" class="privacy-link">链接</a>了解具体内容，并仔细阅读。</div>
    </template>
  </common-confirm>
</template>

<script>
const CommonConfirm = () => import("@/components/Common/CommonConfirm");
export default {
  name: "PrivacyModal",
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value(val) {
      console.log(val)
    }
  },
  data() {
    return {
      privacyLink: "/wz_index_law_privacy/index",
      userAgreementLink: "/wz_index_law/index",
      rewardPrivacyLink: process.env.VUE_APP_BASE_URL + "/content/rewardprivacy"
    }
  },
  components: {
    CommonConfirm
  },
  methods: {
    submitAgree(val) {
      this.$emit('submit',val);
    }
  }
}
</script>

<style scoped lang="less">
.privacy-modal-title {
  text-align: center;
  line-height: 22px;
}
.privacy-modal-content {
  text-indent: 2em;
  line-height: 1.8;
  color: #333333;
}
.btn-module {
  padding: 25px 0;
  text-align: center;
  & > button {
    height: 36px;
    font-size: 16px;
    width: 100px;
    color: #333333;
    border: 1px solid #cccccc;
    background-color: #FFFFFF;
    &:hover {
      background-color: #F0F0F0;
    }
    &:active {
      background-color: #f7f7f7;
    }
    &.is-agree {
      margin-left: 10px;
      border: 1px solid #FBC500;
      background-color: #FBC500;
      &:hover {
        background-color: #daaa09;
      }
      &:active {
        background-color: #FBC500;
      }
    }
  }
}
</style>
